export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {TagProps} from 'kpc';

interface Props {
    tags: TagProps['type'][]
}

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            tags: ['default', 'primary', 'success', 'warning', 'danger']
        } as Props;
    }

    prevent(e: MouseEvent) {
        e.preventDefault();
    }
}